'use client';

import { Bars3BottomLeftIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { cn } from '../../utils/cn';

interface FloatingChapterButtonProps {
  onClick: () => void;
  className?: string;
  show?: boolean;
}

export const FloatingChapterButton: React.FC<FloatingChapterButtonProps> = ({ onClick, className, show = true }) => {
  const [mounted, setMounted] = useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || !show) {
    return null;
  }

  const button = (
    <div className="pointer-events-none fixed bottom-0 left-0 right-0 z-40">
      <div className="pointer-events-none flex justify-end items-center w-full max-w-screen-lg mx-auto p-8">
        <button
          onClick={onClick}
          className={cn(
            'pointer-events-auto',
            'w-14 h-14 rounded-full',
            'bg-white',
            'flex items-center justify-center',
            'transition-all duration-200',
            'hover:scale-105 active:scale-95',
            'focus:outline-hidden focus:ring-2 focus:ring-neutral-300 focus:ring-offset-2',
            className,
          )}
          style={{
            boxShadow: 'rgba(0, 0, 0, 0.5) 0px 0px 10px',
          }}
          aria-label="Open chapters menu"
        >
          <Bars3BottomLeftIcon className="w-6 h-6 text-neutral-700" />
        </button>
      </div>
    </div>
  );

  return createPortal(button, document.body);
};
